import { render, staticRenderFns } from "./NarrativeList.vue?vue&type=template&id=58739de4"
import script from "./NarrativeList.vue?vue&type=script&lang=js"
export * from "./NarrativeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports